export default __webpack_public_path__ + "static/media/cif-sk.30d59a0e.svg";